import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import { Gestor } from "../../types/Revisor/Gestor"

export interface Props {
    gestor: Gestor
}

export const GestorCard: React.FC<Props> = ({ gestor }) => {
    return (
        <Card sx={{ maxWidth: 345 }}>
            <CardActionArea>
                <CardContent>
                    <Typography gutterBottom variant="body1" component="div">
                        Datos Creador
                    </Typography>
                    <Typography gutterBottom variant="body2" component="div">
                        {gestor.txNombres + " " + gestor.txApellidos}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        <strong>Area:</strong> {gestor.area}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        <strong>Unidad:</strong> {gestor.unidad}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}